import { createClient } from "contentful";

const spaceId = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
const accessToken = process.env.REACT_APP_CONTENTFUL_DELIVERY_TOKEN;
const previewAccessToken = process.env.REACT_APP_CONTENTFUL_PREVIEW_TOKEN;
const environment = process.env.REACT_APP_CONTENTFUL_ENVIRONMENT || "master";

export const contentfulClient =
  spaceId && accessToken
    ? createClient({
        space: spaceId,
        accessToken,
        environment,
      })
    : null;

export const contentfulPreviewClient =
  spaceId && previewAccessToken
    ? createClient({
        space: spaceId,
        accessToken: previewAccessToken,
        environment,
        host: "preview.contentful.com",
      })
    : null;

export const hasContentfulConfig = Boolean(spaceId && accessToken);
export const hasContentfulPreviewConfig = Boolean(spaceId && previewAccessToken);

export const getContentfulClient = (usePreview) => {
  if (usePreview && contentfulPreviewClient) return contentfulPreviewClient;
  return contentfulClient;
};
